import { disableBodyScroll, enableBodyScroll, queryAllFocusableElements } from '../../scripts/utils';
import { activateButtonMenuLarge, deactivateButtonMenuLarge } from '../header/header';

const menuLargeClass = 'c-menu-large';
const menuLargeOpenClass = menuLargeClass + '--open';

const menuLargeJsClass = 'js-menu-large';

const menuLargeElements = document.querySelectorAll('.' + menuLargeJsClass) as NodeListOf<HTMLElement>;

let openMenuLargeIndex: number = null;

if (menuLargeElements) {
    // Add custom event listeners
    document.addEventListener('openMenuLarge', (event: CustomEvent) => {
        openMenuLarge(event.detail.index);
    });

    document.addEventListener('closeMenuLarge', () => {
        closeMenuLarge();
    });

    document.addEventListener('toggleMenuLarge', (event: CustomEvent) => {
        toggleMenuLarge(event.detail.index);
    });

    menuLargeElements.forEach((menuLargeElement) => {
        // Add keydown event listener to close the menu
        menuLargeElement.addEventListener('keydown', (event) => {
            // If the menu is open and the escape key is pressed
            if (
                event.key === 'Escape'
                && !event.ctrlKey
                && !event.altKey
                && !event.metaKey
                && !event.shiftKey
                && menuLargeElement.classList.contains(menuLargeOpenClass)
            ) {
                // Close the menu
                closeMenuLarge();
            }
        });

        // Get focusable elements from the menu
        const focusableElements = queryAllFocusableElements(menuLargeElement);

        if (focusableElements.length > 0) {
            // Add keydown event listener on the first focusable element
            focusableElements[0].addEventListener('keydown', (event) => {
                // If the shift and tab keys are pressed
                if (
                    event.key === 'Tab'
                    && !event.ctrlKey
                    && !event.altKey
                    && !event.metaKey
                    && event.shiftKey
                ) {
                    // Close the menu
                    closeMenuLarge();
                }
            });

            // Add keydown event listener on the last focusable element
            focusableElements[focusableElements.length - 1].addEventListener('keydown', (event) => {
                // If the tab key is pressed
                if (
                    event.key === 'Tab'
                    && !event.ctrlKey
                    && !event.altKey
                    && !event.metaKey
                    && !event.shiftKey
                ) {
                    // Close the menu
                    closeMenuLarge();
                }
            });
        }
    });
}

function toggleMenuLarge (index: number) {
    if (
        typeof index !== 'number'
        || !menuLargeElements
        || !menuLargeElements[index]
    ) {
        return;
    }

    // If the menu is open
    if (menuLargeElements[index].classList.contains(menuLargeOpenClass)) {
        closeMenuLarge();
        enableBodyScroll();
    } else {
        openMenuLarge(index);
        disableBodyScroll();
    }
}

function openMenuLarge (index: number) {
    if (
        typeof index !== 'number'
        || !menuLargeElements
        || !menuLargeElements[index]
        || menuLargeElements[index].classList.contains(menuLargeOpenClass)
    ) {
        return;
    }

    const menuLargeElement = menuLargeElements[index];

    // If a menu is already open
    if (openMenuLargeIndex !== null) {
        closeMenuLarge();
    }

    // Activate menu button
    activateButtonMenuLarge(index);

    // Add the active class to the menu
    menuLargeElement.classList.add(menuLargeOpenClass);

    // Update the menu's inert property to allow focus
    menuLargeElement.inert = false;

    // Update the open menu index
    openMenuLargeIndex = index;

    // Dispatch custom event to open backdrop
    document.dispatchEvent(new CustomEvent('openBackdrop'));

    // Disable body scroll
    disableBodyScroll();
}

function closeMenuLarge (): void {
    if (openMenuLargeIndex === null) {
        return;
    }

    const menuLargeElement = menuLargeElements[openMenuLargeIndex];

    // Deactivate menu button
    deactivateButtonMenuLarge(openMenuLargeIndex);

    // Remove the active class from the menu
    menuLargeElement.classList.remove(menuLargeOpenClass);

    // Update the menu's inert property to prevent focus
    menuLargeElement.inert = true;

    // Update the open menu index
    openMenuLargeIndex = null;

    // Dispatch custom event to close backdrop
    document.dispatchEvent(new CustomEvent('closeBackdrop'));

    // Enable body scroll
    enableBodyScroll();
}